import React from 'react'
import { Redirect } from 'react-router-dom'

const LostRoute = (props) => {
  return <Redirect to={props.to} />
}

export default LostRoute
